<template>
    <div class="navigation-buttons">
        <TotemButton
            :disabled="isFirstSection"
            @click="selectCollectionPart(-1)"
            icon="arrow-left"
            size="small" color="secondary"
            class="navigation-buttons__previous-button"
            :label="$t('Microlearning.navigation_previous')"
        />
        <TotemButton
            v-if="isThereCollectionRoute"
            @click="goToCollectionPage"
            icon="stack"
            size="small"
            color="primary"
            class="navigation-buttons__mainpage-button"
            :label="$t('CollectionCourse.navigation_mainpage')"
        />
        <TotemButton
            :disabled="isLastSection"
            @click="selectCollectionPart(1)"
            icon="arrow-right"
            size="small"
            color="secondary"
            class="navigation-buttons__next-button"
            :label="$t('Microlearning.navigation_next')"
        />
    </div>
</template>

<script>
    import routeHelper from 'components/shared/mixins/routeHelper'

    export default {
        name: 'NavigationButtons',
        mixins: [ routeHelper ],
        props: {
            collectionAllCourses: Array,
            currentCourseId: Number
        },
        computed: {
            currentCourse () {
                return this.collectionAllCourses.find(el => el.id === this.currentCourseId)
            },
            coursePositionInArray () {
                return this.collectionAllCourses.indexOf(this.currentCourse)
            },
            isFirstSection () {
                return this.coursePositionInArray === 0
            },
            isLastSection () {
                return this.coursePositionInArray === this.collectionAllCourses.length - 1
            },
            isThereCollectionRoute () {
                return this.$route.params.collectionSlug
            }
        },
        methods: {
            goToCollectionPage () {
                this.$router.push(this.getRouteToCollection(this.$route.params.collectionSlug))
            },
            selectCollectionPart (value) {
                const nextSectionIndex = this.coursePositionInArray + value
                const nextSection = this.collectionAllCourses[nextSectionIndex]
                this.$router.push(this.getRouteToCourse(nextSection))
            }
        }
    }
</script>

<style lang="scss" scoped>
.navigation-buttons {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin: 15px 0;
}
</style>
